import { render } from "./ListIdiomas.vue?vue&type=template&id=6d0f8296"
import script from "./ListIdiomas.vue?vue&type=script&lang=js"
export * from "./ListIdiomas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__